export const PERCENTAGE = 'Percentage';
export const FIXED_AMOUNT = 'Fixed Amount';
export const PRICE_OVERRIDE = 'Price Override';
export const FREE_SETUP = 'Free Setup';
